import { useTranslation } from 'react-i18next';
import { Button } from '../../../../web/src/components/interactive/button.jsx';

/**
 * For-real-nerds use-case mockup: a swagger-ui panel for GET /api/accounts,
 * with the pre-authenticated note.
 * @returns {JSX.Element}
 */
export function ApiScreen() {
	const { t } = useTranslation();
	return (
		<>
			<div className="swagger-mock card">
				<div className="swagger-mock-bar">
					<span className="swagger-mock-title">swagger-ui</span>
					<span className="swagger-mock-url">/~swagger/openapi.json</span>
				</div>
				<div className="swagger-mock-op">
					<div className="swagger-mock-op-row">
						<span className="swagger-method swagger-method-get">GET</span>
						<span className="swagger-mock-path">/api/accounts</span>
					</div>
					<p className="swagger-mock-summary">{t('usecase.api.listAccounts')}</p>
					<div className="swagger-mock-try">
						<Button variant="ghost" size="sm">{t('usecase.api.tryItOut')}</Button>
					</div>
					<pre className="swagger-mock-response">{`{
  "data": [
    { "id": "acct_1", "name": "Checking", "balance": 289400 },
    { "id": "acct_2", "name": "Savings", "balance": 1500000 },
    { "id": "acct_3", "name": "Home", "balance": 35000000 }
  ]
}`}</pre>
				</div>
			</div>
			<div className="use-case-callout card">
				<p>{t('usecase.api.auth')}</p>
			</div>
		</>
	);
}
